import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  faFacebook,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faAddressBook, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { environment } from 'src/environments/environment';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Swal from 'sweetalert2';

declare let fbq: Function;
declare let ttq: any;

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css'],
})
export class ContactFormComponent {
  buttonTextForForm = 'Send';
  contactForm: FormGroup;
  icons: { [key: string]: IconProp } = {
    faFacebook,
    faWhatsapp,
    faLinkedin,
    faEnvelope,
    faInstagram,
    faYoutube,
    faTiktok,
    faAddressBook,
  };

  soicalMediaLinks: any[] = [];
  whatsappLink: string = '';
  whatsappNumber: string = '';
  emailpath: string = '';

  contactImage = `/assets/${environment.projectName}/media/contactusComponents/contact.png`;
  whatAppPath = `/assets/${environment.projectName}/icons/whatsapp-logo.png`;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private fetchDataService: FetchDataService
  ) {
    this.contactForm = this.fb.group({
      fullName: ['', [Validators.required, Validators.pattern('^[\u0600-\u06FFa-zA-Z ]+$')]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('[0-9]+'),
          Validators.minLength(10),
          Validators.maxLength(13),
        ],
      ],
      message: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  ngOnInit() {
    this.fetchDataService.getSocialLinks().subscribe({
      next: (data: any) => {
        this.soicalMediaLinks = data.soicalMediaLinks;
        this.whatsappLink = data.soicalMediaLinks.find(
          (item: any) => item.name === 'whatsapp'
        )?.link;
        this.whatsappNumber = this.whatsappLink?.split('wa.me/')[1] || '';
        this.emailpath = data.soicalMediaLinks.find(
          (item: any) => item.name === 'email'
        )?.link.split('mailto:')[1] || '';
      },
      error: (err) => {
        console.error('Error fetching services:', err);
      },
    });
  }

  get fullName() { return this.contactForm.get('fullName'); }
  get email() { return this.contactForm.get('email'); }
  get phoneNumber() { return this.contactForm.get('phoneNumber'); }
  get message() { return this.contactForm.get('message'); }

onSubmit() {
    if (this.contactForm.valid) {
      this.submitForm(this.contactForm.value).subscribe({
        next: () => {
          this.contactForm.reset();
          this.trackContactRequest();
          Swal.fire({
            icon: 'success',
            title: 'تم الإرسال بنجاح',
            text: 'تم استلام رسالتك وسيتم التواصل معك قريباً',
            confirmButtonText: 'حسناً',
            confirmButtonColor: 'var(--secondary-color)',
            customClass: {
              popup: 'swal-rtl',
            },
          });
          
        },
        error: (err) => {
          if (err.status === 200) {
            this.contactForm.reset();
            this.trackContactRequest();
            Swal.fire({
              icon: 'success',
              title: 'تم الإرسال بنجاح',
              text: 'تم استلام رسالتك وسيتم التواصل معك قريباً',
              confirmButtonText: 'حسناً',
              confirmButtonColor: 'var(--secondary-color)',
              customClass: {
                popup: 'swal-rtl',
              },
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'حدث خطأ',
              text: 'لم يتم إرسال رسالتك، حاول مرة أخرى',
              confirmButtonText: 'حسناً',
              confirmButtonColor: '#d33',
              customClass: {
                popup: 'swal-rtl',
              },
            });
          }
        },
      });
    }
  }
  private trackContactRequest(): void {
    if (typeof fbq !== 'undefined') {
      fbq('trackCustom', 'ContactRequest');
     
    } 

    if (typeof ttq !== 'undefined') {
      ttq.track('SubmitForm');
    
    }
  }

submitForm(data: any) {
  return this.http.post(`${environment.baseURL}api/contact`, data, {
    responseType: 'text'
  });
}
}